var map = {
	"./en-us/SourceHanSerif.otf": [
		67614,
		614
	],
	"./ja-jp/SourceHanSerif.otf": [
		48550,
		550
	],
	"./zh-tw/SourceHanSerif.otf": [
		70480,
		480
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 92891;
module.exports = webpackAsyncContext;